import { TypeRequest } from "../common/enums/AllEnums";
import { IResponse } from "../interfaces/IResponse";
import { BisAPI, BisApiRequest } from "./apis";

export const GetDepartmentsByUserID = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerDepartamentosByUsuarioID?usuarioID=${userID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetDepartments = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerDepartamentos`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

